(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("scheduledReports", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/reports/scheduledReportsView.html",
            controller: ["$localStorage", "$state", "$rootScope", ScheduledReportsCtrl],
            controllerAs: "vm"
        };
        function ScheduledReportsCtrl($localStorage, $state, $rootScope) {
            var vm = this;
            if ($state.params.report) {
                console.log($state.params.filter);
                vm.fromState = $rootScope.fromState;
                vm.fromParams = $rootScope.fromParams;
            }
            if (!$localStorage.scheduledReports) {
                $localStorage.scheduledReports = [
                    {
                        name: "Completions 2017 - to Ken",
                        report: "Learning Path Completions - 2017",
                        frequency: "12:00 on the 1st of every month",
                        cron: "0 12 1 * *",
                        recipients: "kflesher@basecorp.com\nmbrown@basecorp.com",
                        type: "pdf",
                        enabled: true
                    }
                ];
            }
            vm.reports = $localStorage.scheduledReports;
            vm.editReport = function (report) {
                $state.go("main.reporting.editScheduledReport", { report: report });
            };
        }
    });
}());
